var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex gap-8",staticStyle:{"margin-bottom":"0.1rem"}},[_c('LayoutSelect',{staticStyle:{"width":"2rem"},attrs:{"placeholder":"请选择设备","options":_vm.deviceOption,"defaultValue":_vm.params.deviceId},on:{"change":_vm.selectChange}})],1),_c('div',{staticStyle:{"height":"50vh"}},[_c('PaginationTable',{ref:"tableRef",attrs:{"row-key":"pkId","api":_vm.api,"columns":_vm.columns,"scroll":{ x: false, y: 'max-content' },"paginationConfig":{
        size: 'small',
        showQuickJumper: false,
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }